import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { getQueryParams } from 'common/containers/QueueItemListContainer';
import { LocationContext } from 'common/containers/RouterContainer';
import cloneElementWithProps from 'common/core/cloneElementWithProps';

import 'css/components/subdomain/admin/_AdminQueue.scss';

import AdminQueueAuditLog from './AdminQueueAuditLog';
import AdminQueuePosts from './AdminQueuePosts';
import AdminQueueSpam from './AdminQueueSpam';

import type { Company } from 'common/api/endpoints/companies';

const AdminQueueSwitch = (props: Record<string, unknown>) => {
  const location = useContext(LocationContext);
  const company = useContext<Company>(CompanyContext);
  const queryParams = getQueryParams(location);

  if (queryParams?.source === 'spam') {
    return cloneElementWithProps(<AdminQueueSpam />, props);
  }

  if (company.queueAutomation?.enabled) {
    return cloneElementWithProps(<AdminQueueAuditLog />, props);
  }

  return cloneElementWithProps(<AdminQueuePosts />, props);
};

export default AdminQueueSwitch;
